import { LoadingOutlined_str, suggest_CloseCircleFill_str } from '@zenlayer/zen-design-icons';
import { useControllableValue } from 'ahooks';
import classNames from 'classnames';
import { all, equals } from 'ramda';
import React, { useMemo, useState } from 'react';
import { pickDomAttrs } from '../_util/utils';
import SvgIcon from '../svg-icon';
import Input from '../input';
import './style/index';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const BlockCode = props => {
  const {
    length = 6,
    loading,
    disabled,
    type,
    onOk,
    prefixClass = 'zen-design',
    //TODO 写provider时统一改掉
    className,
    style,
    ...restProps
  } = props;
  const baseClassName = "".concat(prefixClass, "-launch-code");
  const attrs = pickDomAttrs(restProps);
  const inputRefs = useMemo(() => Array.from({
    length
  }, () => /*#__PURE__*/React.createRef()), []);
  const [value, setValue] = useControllableValue({
    onChange: v => {
      var _props$onChange;
      (_props$onChange = props.onChange) === null || _props$onChange === void 0 || _props$onChange.call(props, v.join(''));
      all(i => !(i === undefined || i === ''))(v) && (onOk === null || onOk === void 0 ? void 0 : onOk(v.join('')));
    }
  }, {
    defaultValue: Array.from({
      length
    }, () => '')
  });
  return /*#__PURE__*/_jsxs("div", {
    ...attrs.data,
    className: classNames(className, baseClassName, type),
    style: style,
    children: [inputRefs.map((ref, index) => {
      return /*#__PURE__*/_jsx("input", {
        ref: ref,
        type: "text",
        disabled: loading || disabled,
        value: value[index],
        onChange: e => {
          const val = e.target.value;
          if (/^\d*$/.test(val)) {
            let newValue = [...value];
            if (!val) {
              newValue[index] = '';
            } else {
              var _inputRefs$nextInputI;
              const valArr = [...val].slice(0, inputRefs.length - index);
              valArr.forEach((it, i) => {
                newValue[index + i] = it;
              });
              const nextInputIdx = Math.min(index + valArr.length, inputRefs.length - 1);
              (_inputRefs$nextInputI = inputRefs[nextInputIdx].current) === null || _inputRefs$nextInputI === void 0 || _inputRefs$nextInputI.focus();
            }
            if (!equals(newValue, value)) {
              setValue(newValue);
            }
          }
        },
        onKeyDown: e => {
          switch (e.key) {
            case 'Backspace':
              if (index > 0 && !value[index]) {
                var _inputRefs$current;
                (_inputRefs$current = inputRefs[index - 1].current) === null || _inputRefs$current === void 0 || _inputRefs$current.focus();
              }
              break;
            case 'ArrowLeft':
              if (index > 0) {
                var _inputRefs$current2;
                (_inputRefs$current2 = inputRefs[index - 1].current) === null || _inputRefs$current2 === void 0 || _inputRefs$current2.focus();
              }
              break;
            case 'ArrowRight':
              if (index < inputRefs.length - 1) {
                var _inputRefs$current3;
                (_inputRefs$current3 = inputRefs[index + 1].current) === null || _inputRefs$current3 === void 0 || _inputRefs$current3.focus();
              }
              break;
            default:
              break;
          }
        },
        onFocus: () => {
          window.setTimeout(() => {
            var _inputRefs$index$curr;
            (_inputRefs$index$curr = inputRefs[index].current) === null || _inputRefs$index$curr === void 0 || _inputRefs$index$curr.select();
          }, 1);
        }
      }, index);
    }), !!loading && /*#__PURE__*/_jsx(SvgIcon, {
      svgStr: LoadingOutlined_str,
      block: true,
      spin: true
    })]
  });
};
const InputCode = props => {
  const {
    length = 6,
    loading,
    disabled,
    type,
    onChange,
    onOk,
    inputProps,
    prefixClass = 'zen-design',
    //TODO 写provider时统一改掉
    className,
    style,
    ...restProps
  } = props;
  const baseClassName = "".concat(prefixClass, "-launch-code");
  const attrs = pickDomAttrs(restProps);
  const [value, setValue] = useState('');
  return /*#__PURE__*/_jsx(Input, {
    ...attrs.data,
    className: classNames(className, baseClassName, type),
    style: style,
    type: "filled",
    suffix: !!value.length ? /*#__PURE__*/_jsx(SvgIcon, {
      svgStr: suggest_CloseCircleFill_str,
      onClick: () => {
        setValue('');
        onChange === null || onChange === void 0 || onChange('');
      }
    }) : undefined,
    disabled: disabled,
    loading: loading,
    value: value,
    onChange: v => {
      const value = v.replace(/\D/g, '').slice(0, length);
      setValue(value);
      onChange === null || onChange === void 0 || onChange(value);
      value.length === length && (onOk === null || onOk === void 0 ? void 0 : onOk(value));
    },
    ...inputProps
  });
};
const LaunchCode = props => {
  const {
    type = 'block'
  } = props;
  if (type === 'block') {
    return /*#__PURE__*/_jsx(BlockCode, {
      ...props,
      type: "block",
      inputProps: undefined
    });
  } else if (type === 'input') {
    return /*#__PURE__*/_jsx(InputCode, {
      ...props,
      type: "input"
    });
  }
  return null;
};
export default LaunchCode;